import { Injectable } from '@angular/core';
import { CommentDataEntry } from '@osos/shared/api';
import { CommentPresenterModel } from '@osos/shared/types';
import { ParserBase } from '../../bases/parser/parser-base';

@Injectable()
export class CommentParserV1Service extends ParserBase<
  CommentDataEntry,
  CommentPresenterModel
> {
  constructor() {
    super(CommentDataEntry, CommentPresenterModel, 1);
  }

  getPresenterModel(model: CommentDataEntry): CommentPresenterModel {
    const presenter = {
      id: model.id,
      specificationVersion: model.specificationVersion,
      commentText: model.value.commentText,
      attachments: model.value.attachments,
      commenter: model.value.commenter,
      workflowStepId: model.value.workflowStepId,
      workflowStepName: model.value.workflowStepName,
      delegetee: model.creationInfo.delegatee,
      doneAt: model.value.doneAt,
      relatedTo: model.value.relatedTo,
      mentions: model.value.mentions,
      entityId: model.value.relatedTo.dataEntity,
      entryId: model.value.relatedTo.dataEntry,
      audience: model.value.audience,
    } as CommentPresenterModel;
    return presenter;
  }
  getDataModel(presenter: CommentPresenterModel): CommentDataEntry {
    const model = {
      value: {
        ...(presenter?.attachments && { attachments: presenter.attachments }),
        ...(presenter?.commentText && { commentText: presenter.commentText }),
        ...(presenter?.relatedTo && { relatedTo: presenter.relatedTo }),
        ...(presenter?.commenter && { commenter: presenter.commenter }),
        ...(presenter?.workflowStepName && {
          workflowStepName: presenter.workflowStepName,
        }),
        ...(presenter?.workflowStepId && {
          workflowStepId: presenter.workflowStepId,
        }),
        ...(presenter?.doneAt && { doneAt: presenter.doneAt }),
      },
    } as CommentDataEntry;

    return model;
  }
}
